import {
  BrowserModule
} from '@angular/platform-browser';
import {
  BrowserAnimationsModule
} from '@angular/platform-browser/animations';

import {
  NgModule
} from '@angular/core';
import {
  Routes,
  RouterModule
} from '@angular/router';
import {
  AppComponent
} from './app.component';
import {
  ReactiveFormsModule
} from '@angular/forms';
import {
  HttpClientModule,
  HTTP_INTERCEPTORS
} from '@angular/common/http';
import {
  SharedModule
} from './shared/shared.module';
import {
  fakeBackendProvider
} from './_helpers';
import {
  AppRoutingModule
} from './app-routing.module';
import {
  DGXHomeComponent
} from './dgx/dgx-home/dgx-home.component';
import {
  DataIntegrationToolkitHomeComponent
} from './maui/data-integration-toolkit-home/data-integration-toolkit-home.component';
import {
  DataIntegrationToolkitHomeDuComponent
} from './maui/data-integration-toolkit-home-du/data-integration-toolkit-home-du.component';
import {
  DataIntegrationToolkitHomeFrComponent
} from './maui/data-integration-toolkit-home-fr/data-integration-toolkit-home-fr.component';
import {
  DataIntegrationToolkitHomeItComponent
} from './maui/data-integration-toolkit-home-it/data-integration-toolkit-home-it.component';
import {
  DataIntegrationToolkitHomeJpComponent
} from './maui/data-integration-toolkit-home-jp/data-integration-toolkit-home-jp.component';
import {
  DataIntegrationToolkitHomeNtComponent
} from './maui/data-integration-toolkit-home-nt/data-integration-toolkit-home-nt.component';
import {
  DataIntegrationToolkitHomePoComponent
} from './maui/data-integration-toolkit-home-po/data-integration-toolkit-home-po.component';
import {
  DataIntegrationToolkitHomeSpComponent
} from './maui/data-integration-toolkit-home-sp/data-integration-toolkit-home-sp.component';
import {
  MauiLayoutComponent
} from './shared/components/layout/maui-layout/maui-layout.component';
import {
  DGXLayoutComponent
} from './shared/components/layout/dgx-layout/dgx-layout.component';
import { HttpErrorInterceptor } from './_helpers/http-error.interceptor';
import { ToastrModule } from "ngx-toastr";
import { ModalModule } from 'ngx-bootstrap/modal';

@NgModule({
    imports: [
        BrowserModule,
        BrowserAnimationsModule,
        ReactiveFormsModule,
        HttpClientModule,
        AppRoutingModule,
        SharedModule,
        ToastrModule.forRoot(),
        ModalModule.forRoot()
    ],
    declarations: [
        AppComponent,
        MauiLayoutComponent,
        DGXLayoutComponent,
        DGXHomeComponent,
        DataIntegrationToolkitHomeComponent,
        DataIntegrationToolkitHomeDuComponent,
        DataIntegrationToolkitHomeFrComponent,
        DataIntegrationToolkitHomeItComponent,
        DataIntegrationToolkitHomeJpComponent,
        DataIntegrationToolkitHomeNtComponent,
        DataIntegrationToolkitHomePoComponent,
        DataIntegrationToolkitHomeSpComponent
    ],
    exports: [RouterModule],
    providers: [
        fakeBackendProvider,
        {
            provide: HTTP_INTERCEPTORS,
            useClass: HttpErrorInterceptor,
            multi: true
        }
    ],
    bootstrap: [AppComponent]
})
export class AppModule {};
